export default {
  tipo: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  grupoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  contaID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  permissoesDisponiveis: {
    value: [],
    options: [],
    required: true,
    defaultArray: true,
    state: null
  },
  permissoesUsadas: {
    value: [],
    options: [],
    required: true,
    defaultArray: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/permission/permission-form.js